import { PropsWithChildren, ReactNode } from "react";
import { ExamDateDto, OnlinePaymentStatus } from "api";
import { useRegistrationJourneyContext } from "journey";
import { FullScreenLoader } from "./FullScreenLoader";
import { NoSlotsChecker } from "./NoSlotsChecker";
import { RegistrationStepPageLayout } from "./RegistrationStepPageLayout";

export const RegistrationStepPage = ({
  subTitle,
  stepIndex: targetStepIndex,
  completed,
  selectedExam: selectedExamProp,
  backToHome,
  examCardCta,
  hideStepper,
  paymentStatus,
  examCardPlaceholder,
  priceOverride,
  currencyOverride,
  children,
}: PropsWithChildren<{
  subTitle?: string;
  stepIndex?: number;
  completed?: boolean;
  selectedExam?: ExamDateDto;
  backToHome?: boolean;
  examCardCta?: ReactNode;
  hideStepper?: boolean;
  paymentStatus?: OnlinePaymentStatus;
  examCardPlaceholder?: boolean;
  priceOverride?: number | null;
  currencyOverride?: string | null;
}>) => {
  const {
    journey: { stepIndex, selectedExam },
  } = useRegistrationJourneyContext();

  const showLoader =
    targetStepIndex != undefined && targetStepIndex != stepIndex;

  return (
    <>
      <RegistrationStepPageLayout
        stepIndex={stepIndex}
        selectedExam={selectedExam ?? selectedExamProp}
        subTitle={subTitle}
        completed={completed}
        backToHome={backToHome}
        examCardCta={examCardCta}
        hideStepper={hideStepper}
        paymentStatus={paymentStatus}
        examCardPlaceholder={examCardPlaceholder}
        priceOverride={priceOverride}
        currencyOverride={currencyOverride}
      >
        {showLoader ? <FullScreenLoader /> : children}
      </RegistrationStepPageLayout>
      {stepIndex !== 0 && !completed && (
        <NoSlotsChecker examDateId={selectedExam?.id} />
      )}
    </>
  );
};
